var render = function render(){var _vm=this,_c=_vm._self._c;return _c('f7-app',{attrs:{"params":_vm.f7params}},[_c('f7-view',{attrs:{"main":""}},[_c('playback-video',{attrs:{"src":_vm.playback.src,"opened":_vm.playback.opened},on:{"close":function($event){_vm.playback.opened = false}}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }